<div class="service-button-container" (window:scroll)="onScroll($event)">

    <button class="btn service" (click)="openSimpleContactModal()" *ngIf="enableContactButton">
        <svg id="chat" xmlns="http://www.w3.org/2000/svg" width="35.615" height="35.615" viewBox="0 0 35.615 35.615">
            <g id="Grupo_1078" data-name="Grupo 1078" transform="translate(6.678 6.678)">
            <g id="Grupo_1077" data-name="Grupo 1077">
                <path id="Caminho_1767" data-name="Caminho 1767" d="M110.469,96H97.113a1.113,1.113,0,1,0,0,2.226h13.356a1.113,1.113,0,1,0,0-2.226Z" transform="translate(-96 -96)"/>
            </g>
            </g>
            <g id="Grupo_1080" data-name="Grupo 1080" transform="translate(6.678 11.13)">
            <g id="Grupo_1079" data-name="Grupo 1079">
                <path id="Caminho_1768" data-name="Caminho 1768" d="M106.017,160h-8.9a1.113,1.113,0,1,0,0,2.226h8.9a1.113,1.113,0,0,0,0-2.226Z" transform="translate(-96 -160)"/>
            </g>
            </g>
            <g id="Grupo_1082" data-name="Grupo 1082">
            <g id="Grupo_1081" data-name="Grupo 1081">
                <path id="Caminho_1769" data-name="Caminho 1769" d="M24.485,0H4.452A4.456,4.456,0,0,0,0,4.452V26.711A1.112,1.112,0,0,0,.641,27.72a1.129,1.129,0,0,0,.472.1,1.113,1.113,0,0,0,.712-.258l6.368-5.307H24.485a4.456,4.456,0,0,0,4.452-4.452V4.452A4.456,4.456,0,0,0,24.485,0Zm2.226,17.808a2.228,2.228,0,0,1-2.226,2.226H7.791a1.112,1.112,0,0,0-.712.258L2.226,24.336V4.452A2.228,2.228,0,0,1,4.452,2.226H24.485a2.228,2.228,0,0,1,2.226,2.226Z"/>
            </g>
            </g>
            <g id="Grupo_1084" data-name="Grupo 1084" transform="translate(8.904 8.904)">
            <g id="Grupo_1083" data-name="Grupo 1083">
                <path id="Caminho_1770" data-name="Caminho 1770" d="M150.259,128a1.113,1.113,0,1,0,0,2.226,2.228,2.228,0,0,1,2.226,2.226v18.829l-3.757-3.005a1.121,1.121,0,0,0-.695-.243H132.452a2.228,2.228,0,0,1-2.226-2.226v-1.113a1.113,1.113,0,0,0-2.226,0v1.113a4.456,4.456,0,0,0,4.452,4.452h15.19l5.26,4.209a1.114,1.114,0,0,0,1.81-.87V132.452A4.456,4.456,0,0,0,150.259,128Z" transform="translate(-128 -128)"/>
            </g>
            </g>
        </svg>
        <span class="service-text">{{ 'home.service' | translate }}</span>
    </button>
    <button class="btn back-top" [matTooltip]="'home.backTop' | translate" matTooltipClass="tooltip-primary">
        <mat-icon (click)="backTop()" fontSet="material-icons-round">arrow_upward</mat-icon>
    </button>
</div>
